import { Box } from '@mui/material';
import { TabToolbarSlot } from '@/entities/tab/model/tab.types';

interface IProps {
  slot: TabToolbarSlot;
  index: number;
}

export function ToolbarSlot({ slot, index }: IProps) {
  return (
    <Box key={`slot-${index}`} sx={{ display: 'flex', alignItems: 'center' }}>
      {slot}
    </Box>
  );
}
